/**
 * 隐藏导航栏
 */
import { Level, reportCustomMetric, reportError } from "../owl";
import { BridgeType, callKNBBridge, callMSIBridge, getBridgeType } from "./base";

/* ----- setNavigationBarHidden 类型声明 start ----- */
// https://km.sankuai.com/collabpage/419410448
// https://msi-extend.sankuai.com/api?tab=container&id=3675
export enum SHOW_FLAG {
  SHOW = 0,
  HIDE = 1,
}
interface SetNavigationBarHiddenProps {
  flag: SHOW_FLAG;
  success?: () => void;
  fail?: (err: any) => void;
}
/* ----- setNavigationBarHidden 类型声明 end ----- */

interface HideNavigationBarProps {
  onSuccess?: () => void;
  onFail?: (err: any) => void;
}

const bridgeType = getBridgeType();
type HideNavigationBarErrMsg = 'success' | 'KNBBridgeFail' | 'MSIBridgeFail';
function reportHideNavBarSuccessRate(isSuccess: boolean, errMsg: HideNavigationBarErrMsg = "success") {
  reportCustomMetric({
    key: "hideNavigationBar",
    value: isSuccess ? 1 : 0,
    tags: {
      errMsg,
      bridgeType,
    },
  });
}

export default function hideNavigationBar(props?: HideNavigationBarProps) {
  switch (bridgeType) {
    case BridgeType.KNB:
      callKNBBridge("setNavigationBarHidden", {
        flag: SHOW_FLAG.HIDE,
        success: () => {
          if (typeof props?.onSuccess === "function") {
            props.onSuccess();
          }
          reportHideNavBarSuccessRate(true);
        },
        fail: function (error: any) {
          if (typeof props?.onFail === "function") {
            props.onFail(error);
          }
          reportError({
            name: '[hideNavigationBar] KNBHideNavigationBarError',
            msg: error,
            category: 'bridgeError',
            level: Level.WARN,
          })
          reportHideNavBarSuccessRate(false, 'KNBBridgeFail');
        },
      } as SetNavigationBarHiddenProps);
      break;
    case BridgeType.MSI:
      callMSIBridge("setNavigationBarHidden", {
        flag: SHOW_FLAG.HIDE,
        success: () => {
          if (typeof props?.onSuccess === "function") {
            props.onSuccess();
          }
          reportHideNavBarSuccessRate(true);
        },
        fail: (err: any) => {
          if (typeof props?.onFail === "function") {
            props.onFail(err);
          }
          reportError({
            name: '[hideNavigationBar] MSIHideNavigationBarError',
            msg: err,
            category: 'bridgeError',
            level: Level.WARN,
          })
          reportHideNavBarSuccessRate(false, 'MSIBridgeFail');
        },
      } as SetNavigationBarHiddenProps);
      break;
    case BridgeType.GROWTH_MSI:
      break;
    default:
      break;
  }
}
